import { app } from '../../../app';
import { Controller } from './phone-numbers.controller';

app.component('userPhoneNumbers', {
    bindings: {account: '<'},
    controller: Controller,
    templateUrl: require('./phone-numbers.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/phone-numbers.component.js